import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
import { Implement } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Implement';

export class ImplementExtend {
  public static Init(dto: Implement) {
    dto.relationshipType = EnumRelationshipType.Implement;
  }
}
